import { FacebookItem } from '../interfaces/facebook-item.interface';
import { WorkItemBold } from './workitem-bold';
import { WorkItemTypes } from '../constants/workitem-types';

export class WorkItemFacebook extends WorkItemBold implements FacebookItem {
  public readonly type: string = WorkItemTypes.FACEBOOK;
  public messageInitialLoadIsFinished: boolean;

  Name: string;
  Created?: string;
  IsAnswered?: boolean;
  ImageUrl?: string;

  constructor(workItem) {
    super(workItem);

    this.keepAlive = true;
  }
}
